<app-campaign-select2 [selectedItem]="selectedCampaign" (selectedItemChange)="campaignSelected($event)"></app-campaign-select2>
